import { Component, ViewChild, ViewEncapsulation, Input, EventEmitter, Output } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { CRUDActions } from '@app/cp/shared/enums/CRUDActions';
import { ConfirmOutput } from '@app/cp/shared/models/ConfirmOutput';
import { InvoiceService } from '@app/cp/shared/services/invoice.service';
import { BaseAppEditComponent } from '@app/cp/shared/base-components/base-app-edit.component';
import { InvoiceBus } from '@app/cp/shared/models/InvoiceBus';
import { SaveMode } from '../../shared/enums/SaveMode';
import { CommonParam } from '../../shared/models/CommonParam';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { ElementRef } from '@angular/core';
import { CommonValues } from '../../shared/static/CommonValues';
import { CommonFunctions } from '../../shared/static/common-functions';
import { GItem } from '../../shared/models/GItem';
import { MessageType } from '../../shared/enums/MessageType';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { AdditionalInvoiceData } from '../../shared/models/AdditionalInvoiceData';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'invoice-dispute-cm',
    templateUrl: './invoice-dispute-cm.component.html',
    styleUrls: ['./invoice-dispute-cm.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InvoiceDisputeCMComponent extends BaseAppEditComponent<InvoiceBus, InvoiceService>  {
    compLoader: ICPLoader = this as any;
    constructor(globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, svc_data: InvoiceService) {
        super(globals, qry_rd);
        this.appCode = "InvoiceDisputeCM";
        this.svc_data = svc_data;
        this.saveMode = SaveMode.all;
    }
    @Input() localSaveMode: number = 1; //1-Normal, 2-Local Save
    @Input() mode: number = 1; //0-Coll Tab, 1-Normal, 2-Popup
    @Input() data: InvoiceBus;
    @Input() addtlData: AdditionalInvoiceData;
    protected _active: boolean = false;
    @Input() set active(value: boolean) {
        this.beforeActiveSet(value);
        this._active = value;
    }
    @Input() relatedInvoiceData: GItem[];
    @Output() emitReloadCreditMemos: EventEmitter<any> = new EventEmitter();
    get creditMemoApprLimit(): number {
        return this.addtlData ? this.addtlData.creditMemoApprLimit : 0;
    }
    get active(): boolean {
        return this._active;
    }
    beforeActiveSet(value: boolean) {

    }
    protected _reasonElemElemRef: ElementRef;
    @ViewChild('reasonElem') set reasonElem(content: ElementRef) {
        if (content) { // initially setter gets called with undefined
            this._reasonElemElemRef = content;
        }
    }
    protected _rejectedReasonElemElemRef: ElementRef;
    @ViewChild('rejectedReasonElem') set rejectedReasonElem(content: ElementRef) {
        if (content) { // initially setter gets called with undefined
            this._rejectedReasonElemElemRef = content;
        }
    }

    creditMemoReasonCodeId: any;
    creditMemoAmount: number;
    creditMemoStatusId: any;
    currCreditMemoStatusId: any; // to restore to in certain cases
    currCreditMemoAmount: number;
    isDirtyFlag: boolean = false;
    get canSave(): boolean {
        let okToSave: boolean = false;

        if (this.isDirtyFlag) {
            okToSave = CommonFunctions.hasGuidValue(this.creditMemoReasonCodeId)
                && CommonFunctions.hasGuidValue(this.creditMemoStatusId)
                && this.creditMemoAmount != 0
                && CommonFunctions.hasStringValue(this.creditMemoReason);
        }

        return okToSave;
    }
    close(data: any = null, clear: boolean = true) {
        super.close(data, clear);
        this.isDirtyFlag = false;
    }

    cancel() {
        this.close(null, false);
    }
    reasonChanged(e: any) {
        //this.data.creditMemoReason = e.target.value;
        //this.sendParentMessage(MessageType.changedCM);
        this.dataChanged(e);

    }
    rejectedReasonChanged(e: any) {
        //this.data.creditMemoReason = e.target.value;
        //this.sendParentMessage(MessageType.changedCM);
        this.dataChanged(e);

    }
    get creditMemoReason(): string {
        return this._reasonElemElemRef ? this._reasonElemElemRef.nativeElement.value : "";
    }
    set creditMemoReason(value: string) {
        if (this._reasonElemElemRef) {
            this._reasonElemElemRef.nativeElement.value = value;
        }
    }
    get creditMemoRejectedReason(): string {
        return this._rejectedReasonElemElemRef ? this._rejectedReasonElemElemRef.nativeElement.value : "";
    }
    set creditMemoRejectedReason(value: string) {
        if (this._rejectedReasonElemElemRef) {
            this._rejectedReasonElemElemRef.nativeElement.value = value;
        }
    }
    get showRejectedReason(): boolean {
        return this.creditMemoStatusId == CommonValues.InvoiceCreditMemoStatusId_Rejected ? true : false;
    }
    amountChanged(amount: number) {
        if (this.creditMemoStatusId == CommonValues.InvoiceCreditMemoStatusId_Approved && !this.approvedCheck(amount)) {
            setTimeout(() => {
                this.creditMemoAmount = this.currCreditMemoAmount;
            });
            this.cnfShow("The Credit Amount Exceeds your Approval Limit", CRUDActions.None, null, "Need Approval", null, true);
        }
        else {
            this.currCreditMemoAmount = this.creditMemoAmount;
            this.dataChanged(amount);
        }
    }
    statusChanged(e: any) {
        if (e === CommonValues.InvoiceCreditMemoStatusId_Rejected) {
            this.currCreditMemoStatusId = e;
            this.cnfShowNote(this.creditMemoRejectedReason, "Enter Required Reason", 600);
        }
        else if (e === CommonValues.InvoiceCreditMemoStatusId_Approved && !this.approvedCheck(this.creditMemoAmount)) {
            setTimeout(() => {
                this.creditMemoStatusId = this.currCreditMemoStatusId;
            });
            this.cnfShow("The Credit Amount Exceeds your Approval Limit", CRUDActions.None, null, "Need Approval", null, true);
        }
        else {
            this.currCreditMemoStatusId = e;
            this.dataChanged(e);
        }
    }
    approvedCheck(amount: number) : boolean {
        let ok = false;
        if (this.creditMemoReasonCodeId === CommonValues.InvoiceCreditMemoReasonCode_TaxExempt && this.rights.CreditMemoApprovalTaxesOnly)
        {
            ok = true;
        }
        else if (amount <= this.creditMemoApprLimit) {
            ok = true;
        }
        return ok;
    }
    dataChanged(e: any) {

        this.isDirtyFlag = true;
        if (this.localSaveMode !== 1) {
            let data = this.getDataForSave();
            this.sendParentMessage(MessageType.changedCM, null, null, null, data);
        }
        //this.send
    }

    showStatus: boolean = false;
    saveIndividual() {
        let param: CommonParam = this.getDataForSave();
        console.log("inv-disp-cm-b: ",param);
        this.svc_data.saveInvoiceDisputeCMReq(this.data.invoiceId, param).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                console.log("saveind->saveInvoiceDisputeCMReq: ", info);
                this.saveSuccess("Invoice Dispute Credit Memo Required Info Successfully Saved")
                this.close(param, false);
                this.emitReloadCreditMemos.emit(this.data.invoiceId);
            }
            else {
                this.saveError(info.message);
            }
        });
    }
    getDataForSave() : CommonParam {
        let param: CommonParam = new CommonParam();
        param.addParam("CreditMemoReasonCodeId", this.creditMemoReasonCodeId);
        param.addParam("CreditMemoAmount", this.creditMemoAmount);
        param.addParam("CreditMemoReason", this.creditMemoReason);
        param.addParam("CreditMemoRejectedReason", CommonFunctions.getStringValueIfNull(this.creditMemoRejectedReason));
        param.addParam("CreditMemoStatusId", this.creditMemoStatusId);
        return param;
    }
    saveAll() {
        let param: CommonParam = this.getDataForSave();
        this.close(param, false);
    }
    get hasRelatedInvoiceData(): boolean {
        return CommonFunctions.hasArrayElementValue(this.relatedInvoiceData);
    }
    setup() {
        this.isDirtyFlag = false;
        if (this.data) {
            this.creditMemoReasonCodeId = this.data.creditMemoReasonCodeId;
            this.creditMemoAmount = this.data.creditMemoAmount;
            this.creditMemoReason = this.data.creditMemoReason;
            if (CommonFunctions.hasGuidValue(this.data.creditMemoStatusId)) {
                this.creditMemoStatusId = this.data.creditMemoStatusId;
            }
            this.creditMemoRejectedReason = CommonFunctions.getStringValueIfNull(this.data.creditMemoRejectedReason);
            this.currCreditMemoStatusId = this.creditMemoStatusId;
                //this.selectedData = this.data;
//                this.setForm();
            if (this.mode === 1 || this.mode === 2) {
                this.readOnly = false;
            }
        }
    }
    gotoInvoice(item: GItem) {
        if (item) {
            let url: string = "/quickview/service/4/" + item.value;

            this.navigate(url);
        }
    }
    navigate(url: string) {
        setTimeout(() => {
            window.open(url, "_blank");
        });
        //this.router.navigateByUrl(url);
    }
    confirmCustom(data: ConfirmOutput) {
        if (data.dialogResult === CPDialogResult.ok) {
            this.dataChanged(null);
            this.creditMemoRejectedReason = data.data;
        }
    }
}

